import { render, staticRenderFns } from "./lookParticipate.vue?vue&type=template&id=638b1954&scoped=true"
import script from "./lookParticipate.vue?vue&type=script&lang=js"
export * from "./lookParticipate.vue?vue&type=script&lang=js"
import style0 from "./lookParticipate.vue?vue&type=style&index=0&id=638b1954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b1954",
  null
  
)

export default component.exports